export default "__VITE_ASSET__DFptDA71__"